module.exports = __webpack_public_path__ + "img/img10.bd991df6.png";